import materialSymbolsWoff2Url from '@material-symbols/font-400/material-symbols-outlined.woff2?url';
import { log } from '@/utils/core/vueLogger';

let preloadPromise = null;

export function preloadMaterialSymbolsFont() {
	if (preloadPromise) {
		return preloadPromise;
	}

	preloadPromise = (async () => {
		if (typeof window === 'undefined' || typeof document === 'undefined' || typeof FontFace === 'undefined' || !document.fonts) {
			return;
		}

		if (document.fonts.check('24px "Material Symbols Outlined"')) {
			return;
		}

		const materialSymbolsFont = new FontFace('Material Symbols Outlined', `url(${materialSymbolsWoff2Url}) format("woff2")`, {
			style: 'normal',
			weight: '400',
			display: 'block',
		});

		await materialSymbolsFont.load();
		document.fonts.add(materialSymbolsFont);
		log('info', 'MaterialSymbols', 'Material Symbols font preloaded');
	})().catch((error) => {
		log('warn', 'MaterialSymbols', `Material Symbols preload failed: ${error.message}`);
	});

	return preloadPromise;
}
